import React from "react";
import "./IllustrationCard.css";
import { Link } from "react-router-dom";

function IllustrationCard({ imageSrc, title, link }) {
  return (
    <>
      <Link to={link}>
        <div className="IllustrationCard">
          <img src={imageSrc} alt={title} className=" illustration-img" />
        </div>
      </Link>
    </>
  );
}

export default IllustrationCard;
